import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Button } from "reactstrap";
import _ from "lodash";

// actions
import { updateEventSettings } from "components/events/actions";

// components
import {
  renderFieldText,
  renderFieldCheckbox,
} from "components/Common/base-components";

const PEDOMETER_OPTIONS = {
  forall: "Option: Required for all",
  forsome: "Option: Required for some",
  notrequired: "Option: Not required",
};

const RegistrationSettings = (props) => {
  const {
    // state
    session,
    eventSettings,
    pedometerOptions,
  } = props;

  const [isSaving, setIsSaving] = useState(false);
  const [updatedOptions, setUpdatedOptions] = useState(pedometerOptions);

  const hasUpdated = !_.isEqual(pedometerOptions, updatedOptions);

  const handleOptionUpdate = (optKey, prop, val) => {
    let localUpdatedValue = _.cloneDeep(updatedOptions);
    localUpdatedValue[optKey][prop] = val;
    setUpdatedOptions(localUpdatedValue);
  };

  const handleUpdate = () => {
    setIsSaving(true);
    props.updateEventSettings(
      session,
      {
        settingsId: Number(eventSettings?.eventsettingid),
        eventId: Number(eventSettings?.eventidfk),
        value: {
          eventid: eventSettings?.eventidfk,
          pedometer_options: JSON.stringify(updatedOptions),
        },
      },
      (res) => {
        setIsSaving(false);
      }
    );
  };

  return (
    <section>
      <Row>
        <Col sm="12">
          <label htmlFor="">Pedometer Options</label>
        </Col>

        <Col sm="12">
          {!_.isEmpty(pedometerOptions) &&
            _.map(pedometerOptions, (opt, optKey) => {
              return (
                <Row key={`opt${optKey}`}>
                  <Col sm="9">
                    {renderFieldText({
                      type: "text",
                      label: PEDOMETER_OPTIONS[opt?.value],
                      placeholder: "Enter option text",
                      input: {
                        name: `opt${optKey}_label`,
                        value: updatedOptions[optKey]?.label,
                        onChange: (e) =>
                          handleOptionUpdate(
                            optKey,
                            "label",
                            e.target?.value || ""
                          ),
                      },
                      mandatory: true,
                      disabled: !updatedOptions[optKey]?.isenabled,
                      meta: {
                        touched: true,
                        error: _.isEmpty(updatedOptions[optKey]?.label),
                      },
                    })}
                  </Col>

                  <Col sm="3" className="d-flex align-items-center pt-4">
                    {renderFieldCheckbox({
                      type: "checkbox",
                      label: updatedOptions[optKey]?.isenabled
                        ? `Enabled`
                        : `Disabled`,
                      input: {
                        name: `opt${optKey}_isenabled`,
                        checked: updatedOptions[optKey]?.isenabled,
                        onChange: (e) =>
                          handleOptionUpdate(
                            optKey,
                            "isenabled",
                            e.target?.checked || false
                          ),
                      },
                      meta: {
                        touched: true,
                        error: false,
                      },
                    })}
                  </Col>
                </Row>
              );
            })}
        </Col>

        <Col sm="12">
          <Button
            type="button"
            className="float-right"
            color="primary"
            size="md"
            disabled={!hasUpdated || isSaving}
            onClick={() => (hasUpdated ? handleUpdate() : null)}
          >
            <i className={isSaving ? `fa fa-refresh fa-spin` : ""}></i>
            Save
          </Button>
        </Col>
      </Row>
    </section>
  );
};

const mapStateToProps = (state) => {
  const eventDetails = state.SingleEventDetails?.data || {};
  const eventSettings = eventDetails?.eventsettings_by_eventidfk?.[0] || {};
  const pedometerOptions = _.attempt(
    JSON.parse,
    eventSettings?.pedometer_options || {}
  );

  return {
    session: state.session,
    eventSettings,
    pedometerOptions,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateEventSettings }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  RegistrationSettings
  // reduxForm({
  //   // validate,
  //   form: MY_FORM_NAME,
  //   enableReinitialize: true,
  //   keepDirtyOnReinitialize: true,
  // })(RegistrationSettings)
);
